const ChainLightning = ({ showAll }) => (
  <div className='weapon'>
    {!showAll && <div className='title'>You should pick Chain Lightning</div>}
    {showAll && <div className='title'>Chain Lightning</div>}
  </div>
);

export default ChainLightning;
